/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type {
  ElasticsearchResourceInfo,
  ClusterInstanceInfo,
  TransientElasticsearchPlanConfiguration,
} from '@modules/cloud-api/v1/types'
import type { AsyncRequestState, StackDeployment } from '@modules/ui-types'

import { getEsClusterVacateValidate } from '@/reducers/vacateEsClusters'
import {
  vacateEsClusterValidateRequest,
  vacateEsClusterRequest,
} from '@/reducers/asyncRequests/registry'

import { vacateEsCluster } from '../../../../actions/clusters'

import VacateNodeThroughResourceModal from './VacateNodeThroughResourceModal'

type StateProps = {
  vacateEsClusterRequest: AsyncRequestState
  vacateEsClusterValidateRequest: AsyncRequestState
  vacateEsClusterValidateResult?: TransientElasticsearchPlanConfiguration
}

type DispatchProps = {
  vacateEsCluster: (options: { payload?: TransientElasticsearchPlanConfiguration }) => Promise<any>
  vacateEsClusterValidate: (options: { instancesDown?: boolean }) => Promise<any>
}

type ConsumerProps = {
  deployment: StackDeployment
  resource: ElasticsearchResourceInfo
  instance: ClusterInstanceInfo
  close: () => void
  onAfterVacate: () => void
}

const mapStateToProps = (
  state,
  {
    deployment: { id: deploymentId },
    resource: { ref_id: refId },
    instance: { instance_name },
  }: ConsumerProps,
): StateProps => ({
  vacateEsClusterRequest: vacateEsClusterRequest(state, deploymentId, refId, instance_name),
  vacateEsClusterValidateResult: getEsClusterVacateValidate(state, deploymentId, refId, [
    instance_name,
  ]),
  vacateEsClusterValidateRequest: vacateEsClusterValidateRequest(
    state,
    deploymentId,
    refId,
    instance_name,
  ),
})

const mapDispatchToProps = (
  dispatch,
  { deployment, resource, instance: { instance_name } }: ConsumerProps,
): DispatchProps => ({
  vacateEsCluster: ({ payload }: { payload?: TransientElasticsearchPlanConfiguration } = {}) =>
    dispatch(
      vacateEsCluster({
        deployment,
        resource,
        instanceIds: [instance_name],
        validateOnly: false,
        payload,
      }),
    ),
  vacateEsClusterValidate: ({ instancesDown }: { instancesDown?: boolean } = {}) =>
    dispatch(
      vacateEsCluster({
        deployment,
        resource,
        instanceIds: [instance_name],
        validateOnly: true,
        instancesDown,
      }),
    ),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(VacateNodeThroughResourceModal)
